import { Notification } from "@/domains/toasts/constants/notifications";

const NotificationIcons = {
  [Notification.SeatbeltToggledOn]: "seatbelt",
  [Notification.SeatbeltToggledOff]: "seatbelt",
  [Notification.EngineToggledOn]: "engine",
  [Notification.EngineToggledOff]: "engine",
};

export default NotificationIcons;
